/**
 * Gabarits de jalons par programme — repris **mot pour mot** du PAD
 * (`Data Scaleups` pour les 11 échéances, `Milestone Monitoring` ligne 8 pour
 * les 6 revues et leurs 23 fiches de validation).
 *
 * Point de départ, jamais une contrainte : un projet peut ensuite ajouter,
 * retirer ou renommer un jalon comme une fiche (maquette écran 1).
 */
import type { ProgramType } from '@altyor-kronos/shared-types';

export interface MilestoneTemplate {
  templateId: string;
  name: string;
  /** Présent = ce jalon porte une revue formelle. */
  reviewName?: string;
  /** Libellés PAD des fiches et questions rattachées à la revue. */
  deliverables: string[];
}

const SCALEUP: MilestoneTemplate[] = [
  {
    templateId: 'kick-off', name: 'Date kick off customer',
    reviewName: 'Kick-Off OK => Go for Architecture',
    deliverables: [
      // Les deux premières précèdent la colonne de décision dans `Milestone
      // Monitoring` (colonnes 5 et 6) : elles appartiennent bien à ce gate. Les
      // omettre ferait perdre leur saisie à la reprise du PAD.
      'AP TRANSFER MEETING',
      'REVIEW OF COMPLIANCE MATRIX WITH CUSTOMER',
      'FV Design', 'FV Compliance Matrix', 'FV Qualification plan',
      'FV Mechanical Architecture', 'FV Electronic Architecture',
      'COST FILE UPDATE',
      'EMAIL TO THE CUSTOMER TO INFORM ABOUT FIELD TESTS',
      'IS MY PROJECT RISKY AT THIS STAGE ?',
    ],
  },
  {
    templateId: 'architecture-sor', name: 'Architecture design SOR',
    reviewName: 'Architecture OK => Go for Conception',
    deliverables: [
      'FV Mechanical Design - Phase 1', 'FV Mechanical prototype - Phase 1',
      'FV Schematic - Phase 1', 'FV Routing - Phase 1',
      'FV PCBA files - Phase 1', 'FV PCBA - Phase 1',
      'FV Mechanical Design - Phase 2', 'FV Mechanical prototype - Phase 2',
      'FV Schematic - Phase 2', 'FV Routing - Phase 2',
      'FV PCBA files - Phase 2', 'FV PCBA - Phase 2',
    ],
  },
  { templateId: 'proto1-physical', name: 'Prototype 1 - Physical parts', deliverables: [] },
  { templateId: 'proto1-qualified', name: 'Prototype 1 - Qualified', deliverables: [] },
  {
    templateId: 'protof', name: 'ProtoF',
    reviewName: 'Pf OK => Go for DFM',
    deliverables: [
      'FV PROTO F', 'FV TBSOR',
      'ENQUÊTE DE SATISFACTION CLIENT', 'COST FILE UPDATE PF',
      'Deliverables list checked at PF', 'IS MY PROJECT RISKY AT THIS STAGE ?',
      'REX PROJECT PF',
    ],
  },
  { templateId: 'indus-kickoff', name: 'Industrialisation kick-off', deliverables: [] },
  {
    templateId: 'dfm', name: 'DFM',
    reviewName: 'DFM OK => Go for PR2',
    deliverables: ['FV DFM MECA', 'FV DFM ELEC', 'IS MY PROJECT RISKY AT THIS STAGE ?'],
  },
  { templateId: 'er-mr', name: 'ER / MR', deliverables: [] },
  {
    templateId: 'pr', name: 'PR',
    reviewName: 'PR OK => Go for SR',
    deliverables: [
      'FV PR', 'CERTIFICATION STATUS', 'ENQUÊTE DE SATISFACTION CLIENT PR',
      'COST FILE UPDATE PR', 'IS MY PROJECT RISKY AT THIS STAGE ?', 'REX PROJECT PR',
    ],
  },
  {
    templateId: 'sr', name: 'SR',
    reviewName: 'SR OK => Go for SOP',
    deliverables: [
      'FV SR', 'ENQUÊTE DE SATISFACTION CLIENT SR', 'COST FILE UPDATE SR',
      'Deliverables list checked OK at SR', 'IS MY PROJECT RISKY AT THIS STAGE ?',
      'REX PROJECT SR',
    ],
  },
  { templateId: 'sop', name: 'SOP', deliverables: [] },
];

// ponytail: J1–J4 pour tout ce qui n'est pas ScaleUp — c'est déjà le comportement
// actuel (DEFAULT_MILESTONES) et le PAD ne décrit de revues que pour ScaleUp.
const SIMPLE: MilestoneTemplate[] = ['J1', 'J2', 'J3', 'J4'].map((n, i) => ({
  templateId: `j${i + 1}`, name: n, deliverables: [],
}));

export const PROGRAM_TEMPLATES: Record<ProgramType, MilestoneTemplate[]> = {
  ScaleUp: SCALEUP,
  LaunchPad: SIMPLE,
  UnLock: SIMPLE,
  DiagDesign: SIMPLE,
  DiagEco: SIMPLE,
  DiagAmorcageIndus: SIMPLE,
  Internal: SIMPLE,
};
